var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LinkedIn"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.3333 5.66669C13.571 5.66669 14.758 6.18537 15.6332 7.10862C16.5083 8.03188 17 9.28408 17 10.5898V16.3334H13.8889V10.5898C13.8889 10.1545 13.725 9.73714 13.4333 9.42938C13.1415 9.12163 12.7459 8.94874 12.3333 8.94874C11.9208 8.94874 11.5251 9.12163 11.2334 9.42938C10.9417 9.73714 10.7778 10.1545 10.7778 10.5898V16.3334H7.66666V10.5898C7.66666 9.28408 8.15832 8.03188 9.03349 7.10862C9.90866 6.18537 11.0956 5.66669 12.3333 5.66669Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.33333 6.33331H1V16.3333H4.33333V6.33331Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.66667 4.33333C3.58714 4.33333 4.33333 3.58714 4.33333 2.66667C4.33333 1.74619 3.58714 1 2.66667 1C1.74619 1 1 1.74619 1 2.66667C1 3.58714 1.74619 4.33333 2.66667 4.33333Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.3b65025b133ea7b95a672488aa42f71f.svg";
export { ForwardRef as ReactComponent };